module.exports = __webpack_public_path__ + "img/job-not-found.53b18d84.svg";